import { Phone, MapPin, Clock, ArrowRight } from "lucide-react";
import { SITE } from "../../lib/site-data";

export const Hero = () => {
  return (
    <section id="top" data-testid="hero" className="relative overflow-hidden">
      <div className="absolute inset-0 bg-paper" aria-hidden />
      <div className="absolute inset-0 bg-stripes opacity-60" aria-hidden />
      <div className="absolute -top-32 -right-32 w-[440px] h-[440px] rounded-full bg-[#8B2332]/8 blur-3xl" aria-hidden />
      <div className="absolute -bottom-40 -left-20 w-[420px] h-[420px] rounded-full bg-[#D4A24C]/15 blur-3xl" aria-hidden />

      <div className="relative max-w-6xl mx-auto px-5 sm:px-8 pt-12 pb-20 md:pt-20 md:pb-28">
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <div className="eyebrow mb-4" data-testid="hero-eyebrow">
              Burlington, NC · Family Owned
            </div>
            <h1
              className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1F1B16] leading-[1.05]"
              data-testid="hero-title"
            >
              Trailers built for the{" "}
              <span className="text-[#8B2332]">long haul.</span>
            </h1>
            <p
              className="mt-5 text-base sm:text-lg text-[#3A332B] max-w-xl leading-relaxed"
              data-testid="hero-subtitle"
            >
              Car haulers and utility trailers ready when you are. Pick up,
              drop off and bookings — open <strong>24/7</strong>, every day of
              the week.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <a
                href={SITE.bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-book-btn"
                className="btn-brand inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold"
              >
                Reserve a Trailer <ArrowRight className="w-4 h-4" />
              </a>
              <a
                href="#fleet"
                data-testid="hero-fleet-btn"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold border-2 border-[#1F1B16] text-[#1F1B16] hover:bg-[#1F1B16] hover:text-[#F8F4ED] transition"
              >
                See the Fleet
              </a>
            </div>

            <div className="mt-10 grid grid-cols-3 gap-4 max-w-md">
              <Stat icon={<Clock className="w-4 h-4" />} label="Hours" value="24/7" />
              <Stat icon={<MapPin className="w-4 h-4" />} label="Based" value="Burlington" />
              <Stat icon={<Phone className="w-4 h-4" />} label="Call" value={SITE.phone} small />
            </div>
          </div>

          <div className="relative">
            <div
              className="relative aspect-square rounded-[28px] overflow-hidden bg-gradient-to-br from-[#8B2332] to-[#1F1B16] shadow-[0_30px_60px_-25px_rgba(31,27,22,.45)]"
              data-testid="hero-logo-card"
            >
              <img
                src={SITE.logoUrl}
                alt="Long Horn Trailer Rentals"
                className="absolute inset-0 w-full h-full object-cover scale-[1.45] origin-center"
              />
              <div className="absolute inset-3 rounded-[22px] border border-[#D4A24C]/50 pointer-events-none" aria-hidden />
            </div>
            <div className="absolute -bottom-6 -left-6 sm:-left-10 bg-white border border-[#E5DCC9] rounded-2xl px-5 py-4 shadow-lg max-w-[260px]">
              <div className="text-[11px] uppercase tracking-[0.18em] text-[#8B2332] font-semibold">
                Fleet
              </div>
              <div className="font-display text-2xl font-bold text-[#1F1B16]">
                4 Trailers Ready
              </div>
              <div className="text-xs text-[#3A332B] mt-1">
                Car haulers · Utility · Car towing
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="divider-gold" aria-hidden />
    </section>
  );
};

const Stat = ({ icon, label, value, small }) => (
  <div className="rounded-xl border border-[#E5DCC9] bg-white/70 backdrop-blur px-3 py-3">
    <div className="flex items-center gap-1.5 text-[#8B2332]">{icon}<span className="text-[10px] uppercase tracking-[0.15em] font-semibold">{label}</span></div>
    <div className={`font-display font-bold text-[#1F1B16] mt-1 ${small ? "text-sm" : "text-lg"}`}>{value}</div>
  </div>
);
